<template>
  <section>
    <fixed-header title="Interview Questions" :records="pageInfo.totalItems" hideNewOfferBtn hideBackBtn>
      <b-button
        @click="add()"
        size="sm"
        variant="primary"
        title="Add"
        style="float: right;margin-bottom: 5px;">
        <i class="fa fa-plus" aria-hidden="true"></i> Add
      </b-button>
    </fixed-header>
    <div class="card">
      <div class="card-body">
        <grid-component
          isResizable
          isReorderable
          isSortable
          :gridId="gridId"
          :pageable="pageable"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :itemData="itemData"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :fields="fields"
          :sortBy="pageInfo.sort"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortGrid"
          :onEdit="edit"
            @getData="onGetData"
          />
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { debounce } from 'lodash';
import gridFields from './fields';
import GridComponent from '@/shared/components/GridComponent';
const SEARCH_DEBOUNCE_TIME = 750;
import { GRID_ID,GRID_PAGE_SIZES } from '@/shared/constants';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';

export default {
  components: {
    GridComponent,
    FixedHeader
  },
  data() {
    return {
      sort2: [],
      fields: gridFields,
      gridId: GRID_ID.INTERVIEW_QUESTIONS_GRID,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
    };
  },
  computed: {
    ...mapState('interviewquestions', [
      'gridList',
      'pageInfo',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if (this.gridList == undefined || !this.gridList.length) return [];
      return this.gridList;
    },
  },
  methods: {
    ...mapActions('interviewquestions', [
      'getAll',
      'sortGrid',
      'remove',
    ]),
    ...mapMutations('interviewquestions',['setItem']),
    async onGetData(params) {
			await this.getAll(params);
		},
    onRowClick: function(event){
      this.edit(event.dataItem);
    },
    edit(item) {
      this.$router.push({ name: 'interviewquestionEdit', params: { id: item.id } });
    },
    add() {
      this.$router.push({ name: 'interviewquestionAdd' });
    },
    getNestedValue: function(field, dataItem) {
      console.log(field, dataItem)
    },
  },
  created() {
    this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
    this.getAll({});
  },
};
</script>
<style>
.b-pagination {
  justify-content: center;
}

#KendoGrid .k-virtual-scrollable-wrap table
{
    min-width: 800px;
}
</style>
